const keys: Array<string> = [
  'bp.points',
  'detailDisplay.customerPictures.title',
  'detailsDisplay.review.number',
  'general.button.signin',
  'general.more.information',
  'helpProductEvaluation.link.text',
  'mzp.bonuspoints.savemore',
  'mzp.bonuspoints.tabs.more',
  'productDetail.tabs.title.analyticalconstituents',
  'productDetail.tabs.title.description',
  'productDetail.tabs.title.feedingrecommendation',
  'productDetail.tabs.title.ingredients',
  'productDetail.tabs.title.reviews',
  'productReview.latest.reviews',
  'productReview.noreviews',
  'review.total.number',
  'bp.productdetail.carrousel.nextbutton',
  'bp.productdetail.carrousel.previousbutton',
  'bp.productdetail.carrousel.thumbItemPrefixLabel',
  'bp.productdetail.carrousel.lightbox.name',
  'bp.productdetail.carrousel.lightbox.openbutton',
  'bp.productdetail.carrousel.lightbox.closebutton',
  'bp.productdetail.addtocart.cartbutton',
  'bp.productdetail.addtocart.loadingbutton',
  'bp.productdetail.addtocart.quantitypicker',
  'bp.productdetail.addtocart.referencezoopoints.desc',
  'bp.productdetail.rating.label',
  'bp.productdetail.rating.notrated.label',
];

export default keys;
